import React from "react";
import { Modal, Table, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { DemoAccount } from "types/analyticsTypes";

interface DemoAccountsModalProps {
  opened: boolean;
  onClose: () => void;
  accounts: DemoAccount[];
}

const DemoAccountsModal: React.FC<DemoAccountsModalProps> = ({ opened, onClose, accounts }) => {
  const { t } = useTranslation();

  return (
    <Modal opened={opened} onClose={onClose} title={t("analytics.demoAccounts.title")} size="xl">
      <Table.ScrollContainer minWidth={560} maxHeight={480}>
        <Table withRowBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("analytics.demoAccounts.account")}</Table.Th>
              <Table.Th>{t("analytics.demoAccounts.distributor")}</Table.Th>
              <Table.Th>{t("analytics.demoAccounts.type")}</Table.Th>
              <Table.Th ta="right">{t("analytics.demoAccounts.tests")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {accounts.map((account) => (
              <Table.Tr key={account.orgId}>
                <Table.Td>
                  <Text size="sm" fw={600}>
                    {account.orgName}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {account.orgId}
                  </Text>
                </Table.Td>
                <Table.Td>{account.distId}</Table.Td>
                <Table.Td>{account.accountType.join(", ").toUpperCase()}</Table.Td>
                <Table.Td ta="right" fw={600}>
                  {account.demoTests.toLocaleString()}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Modal>
  );
};

export default DemoAccountsModal;
